import { render, staticRenderFns } from "./YogaPayment.vue?vue&type=template&id=184d19f2&scoped=true&"
import script from "./YogaPayment.vue?vue&type=script&lang=js&"
export * from "./YogaPayment.vue?vue&type=script&lang=js&"
import style0 from "./YogaPayment.vue?vue&type=style&index=0&id=184d19f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184d19f2",
  null
  
)

export default component.exports